class BrandedEmailSettingsMapper {
  static createEmailsModel = data => ({
    emailType: data.email_type,
    active: data.active
  });
  static createBrandedSettingsModel = data => {
    return {
      companyLogoUrl: data.company_logo_url,
      companyName: data.company_name,
      companyReplyToEmail: data.company_reply_to_email
    };
  };
  static createBrandedEmailSettingsFromResponse(data) {
    return {
      brandedSettings: data.branded_settings && this.createBrandedSettingsModel(data.branded_settings) || undefined,
      emails: data.emails.map(this.createEmailsModel)
    };
  }
  static createBrandedEmailImplementationFromResponse(data) {
    return {
      emailType: data.email_type,
      locale: data.locale,
      subject: data.subject,
      body: data.body
    };
  }
}

export { BrandedEmailSettingsMapper };
//# sourceMappingURL=BrandedEmailSettingsMapper.js.map
